// src/api/material/docs.js
import api from "../axios";

const ensureProject = (p) => {
  if (p) return p;
  try {
    return localStorage.getItem("projectId") || null;
  } catch (_) {
    return null;
  }
};

/**
 * 자재 문서 상세 조회
 */
export const getMaterialDoc = async ({ dns, project }) => {
  if (!dns) throw new Error("getMaterialDoc: dns 필요");

  const res = await api.get(`material/docs/${dns}/`, {
    params: project ? { project } : undefined,
  });
  return res.data;
};

/**
 * 자재 문서 목록 조회
 */
export const getMaterialDocs = async ({ project, form_type, page = 1, page_size = 20 }) => {
  const pj = ensureProject(project);
  if (!pj) throw new Error("getMaterialDocs: project 필요");

  const res = await api.get("material/docs/", {
    params: { project: pj, form_type, page, page_size },
  });
  return res.data;
};

/**
 * 자재 문서 생성
 */
export const createMaterialDoc = async (payload) => {
  const res = await api.post("material/docs/", payload);
  return res.data;
};

/**
 * 자재 문서 수정
 */
export const updateMaterialDoc = async (dns, payload) => {
  const res = await api.patch(`material/docs/${dns}/`, payload);
  return res.data;
};

/**
 * 자재 문서 삭제
 */
export const deleteMaterialDoc = async (dns) => {
  const res = await api.delete(`material/docs/${dns}/`);
  return res.data;
};
